import React from 'react';
import webapi from '../../../api/webapi';
import TagResultList from './TagResultList';
import Loading from '../modal/Loading';
import EmptyDiv from '../Footer/EmptyDIV';
import '../../css/react-tabs2.css';

class TagsBody extends React.Component {
    // state = { loadingShow : false }
    // state = { filter : "" }
    // state = { filterTitle : "" }
    // state = { results : "" }
    

    constructor(props) {
        super(props);
    
        this.state = { books: [] };
        this.state = { chapters: [] };
        this.state = { SelectedBookGroup: '' };
        this.state = { SelectedBook: '' };
        this.state = { SelectedChapter: '' };
        this.state = { SelectedWordCategory: '' };
        this.state = { pageData: [] };
        this.state = { loadingShow: false };
    }

    componentDidMount() {
        this.setState({loadingShow:true})
        this.setState({ SelectedBook: '' });
        this.setState({ SelectedChapter: '' });

        this.GetBookGroups();
        this.GetWordCategory();

        this.setState({loadingShow:false})

        //fetch('https://api.ipify.org/?format=json')
        // fetch('https://geolocation-db.com/json/')
        //     .then(response => {
        //         return response.json();
        //     }, "jsonp")
        //     .then(res => {
        //         this.setLog('pages/log/Tags/visit/'+res.IPv4.replaceAll('.',','))
        //     })
        //     .catch(err => this.setLog('pages/log/Tags/visit/'+err));
        
        this.getPage();
    };

    async setLog(Data) {
        await webapi.post(Data);
    }

    async getPage() {
        if (this.props.languageInfo)
        {
            const pageList = await webapi.get('pages/datapages/203/'+this.props.languageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/203/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }
    }

    GetBookGroups = async () =>{
        await webapi.get('surf/allbookgroups/'+this.props.languageInfo[0].Code)
            .then(res => {
                this.setState({ BookGroups: res.data});
                if (res.data && res.data[0] && res.data[0].Code)
                {
                    this.setState({ SelectedBookGroup : res.data[0].Code},() => {} );
                    this.GetBooks(res.data[0].Code);
                }
                else
                {
                    this.setState({SelectedBook : ''})
                    this.setState({SelectedChapter : ''})
                }
            })
    }

    GetBooks = async BookGroupCode =>{
        this.setState({loadingShow:true})
        await webapi.get('surf/bookgroupsbook/'+BookGroupCode+'/'+this.props.languageInfo[0].Code)
            .then(res => {
                this.setState({ books: res.data });
            
                if (res.data && res.data[0] && res.data[0].Code)
                {
                    if (res.data.length===1)
                    {
                        this.setState({ SelectedBook : res.data[0].Code },() => {} )
                        this.GetChapters(res.data[0].Code)
                    }
                    else
                    {
                        this.setState({ SelectedBook : 'All' });
                        this.GetChapters('All');
                    }
                }
                else
                {
                    this.setState({SelectedBook : ''})
                    this.setState({SelectedChapter : ''})
                }  
        })              
    }

    GetChapters = async BookCode =>{
        this.setState({loadingShow:true})
        await webapi.get('surf/bookschapter/'+ BookCode+'/'+this.props.languageInfo[0].Code)
            .then(res => {
                this.setState({ chapters: res.data });
           
                
                //if ((this.state.chapters)&&(this.state.chapters!==undefined)&&(this.state.chapters.length>0))
                if (res.data && res.data[0] && res.data[0].Code){
                    if (res.data.length===1){
                        this.setState({ SelectedChapter : res.data[0].Code })
                    } else {
                        this.setState({ SelectedChapter : 'All' });
                    }
                }else{
                    console.log(res.data)
                    this.setState({ SelectedChapter : 'All' });
                }
                this.setState({loadingShow:false})        
            })
    }

    GetWordCategory = async () => {
        this.setState({loadingShow:true})
        await webapi.get('tags/allwordcategorys/'+this.props.languageInfo[0].Code)
            .then(response => {
                this.setState({ wordcategory: response.data});
            })
        if (this.state.wordcategory!==undefined)
        {
            this.setState({ SelectedWordCategory : this.state.wordcategory[0].Code })
        }
        this.setState({loadingShow:false}) 
    }

    onChangeBookGroupSelect = async event => {
        this.setState({loadingShow:true})
        this.setState({ results: '' });
        this.setState({ SelectedBookGroup: event.target.value});
        
        this.GetBooks(event.target.value);
    };

    onChangeBookSelect = async event => {
        this.setState({loadingShow:true})
        this.setState({ results: '' });
        this.setState({ SelectedBook: event.target.value},()=>{});
        
        this.GetChapters( event.target.value );
    };

    onChangeChapterSelect = async event => {
        this.setState({ results: '' });
        this.setState({ SelectedChapter:event.target.value }, () => {})
    };

    

    onChangeWordCategorySelect = async event => {
        //console.log("bookcode", event.target.value)
        this.setState({loadingShow:true})
        this.setState({ results: '' });
        this.setState({ wordpropertytype: ''});
        this.setState({ SelectedWordCategory: event.target.value});
        var x;
        await webapi.get('tags/wordpropertytype/'+event.target.value+'/'+this.props.languageInfo[0].Code)
            .then(response => {
                this.setState({ wordpropertytype: response.data},()=>{

                    if ((this.state.wordpropertytype)&&(this.state.wordpropertytype.length>0))
                    {
                        this.setState({filterTitle:(this.state.pageData.length!==0 && this.state.pageData[0].F29902!== undefined?this.state.pageData[0].F29902:29902)/*"همه"*/});
                        this.setState({filter:"All"});
                        x = document.getElementsByClassName("content");
                        x[0].style.display = "block";
                    }
                    else
                    {
                        this.setState({filterTitle:""});
                        this.setState({filter:""});
                        x = document.getElementsByClassName("content");
                        x[0].style.display = "None";
                    }

                });
                //console.log(response.data);
            })

        x = document.getElementsByClassName("collapsible");
        x[0].style.display = "None";
        this.setState({loadingShow:false})
    };

    onChangeWordPropertySelect = event => {
        //console.log("Itemcode", event.target.value)
        this.setState({ results: '' });
        var filter="All";
        var filterTitle=(this.state.pageData.length!==0 && this.state.pageData[0].F29902!== undefined?this.state.pageData[0].F29902:29902)/*"همه"*/;
        var coll = document.getElementsByClassName("SelectItems");
        var i;
        

        for (i = 0; i < coll.length; i++) {
            if(coll[i].value!=="All")
            {
                if (filter==="All")
                {
                    filter=coll[i].value;
                    filterTitle=coll[i][coll[i].selectedIndex].text;
                }
                else
                {
                    filter=filter+","+coll[i].value;                    
                    filterTitle=filterTitle+"، "+coll[i][coll[i].selectedIndex].text;
                }
                
            }
        }
        if (filter==="")
            filter="All";
        if (filterTitle==="")
            filterTitle=(this.state.pageData.length!==0 && this.state.pageData[0].F29902!== undefined?this.state.pageData[0].F29902:29902)/*"همه"*/;
        this.setState({filter:filter});
        this.setState({filterTitle:filterTitle});
    };

    onSearchButtonClick = event => {
        event.preventDefault();
        //console.log(this.state.filter);
        //console.log(this.state.filterTitle);
        var x = document.getElementsByClassName("content");
        x[0].style.display = "None";

        //console.log((this.state.filter));
        //console.log((this.state.filter===undefined));
        //console.log((this.state.filter===""));

        if (((this.state.filter===undefined)||(this.state.filter==="")))
        {
            //console.log(1);
            x = document.getElementsByClassName("collapsible");
            x[0].style.display = "None";
        }
        else
        {
            //console.log(2);
            x = document.getElementsByClassName("collapsible");
            x[0].style.display = "block";
            this.Search(this.state.SelectedWordCategory+"/"+this.state.filter+"/"+this.state.SelectedBookGroup+"/"+this.state.SelectedBook+"/"+this.state.SelectedChapter);
        }
    };

    Search = async filter => {
        //console.log(filter);
        this.setState({ results: ''});
        this.setState({loadingShow : true})
        //tags/textproperty/{CategoryCode}/{TextProperty}/{Book}/{Chapter}
        await webapi.get('tags/textproperty/'+filter)
            .then(response => {
                //console.log(response.data);
                //console.log('tags/textproperty/'+filter);
                this.setState({ results: response.data});
                this.setState({loadingShow : false})
            })
            .catch(error => {
                this.setState({loadingShow : false})
                //console.log(error);
            });

        
    }


    onCollapsibleButtonClick = event => {
        var x = document.getElementsByClassName("content");
        
        if (x[0].style.display === "block") {
            x[0].style.display = "none";
            event.target.style.display="block";
        } else {
            x[0].style.display = "block";
            event.target.style.display="none";
        }
    };

    render() {
        if (this.state.pageData)
        return (
            [
                <div className="container-fluid" id="innerpage_row_1">
                        <div className="container">
                            <h1 id="page_title">{this.state.pageData.length!==0 && this.state.pageData[0].F203!== undefined?this.state.pageData[0].F203:203/*جستجوی برچسب دستوری*/}</h1>
                            <h2 id="page_title_dek">{this.state.pageData.length!==0 && this.state.pageData[0].F20300!== undefined?this.state.pageData[0].F20300:20300/*مقوله دستوری واژه‌های فارسی میانه*/}</h2>
                            <hr className="halfwidth" />
                        </div>
                </div>
                ,
                <div className="container-fluid" id="tags_main_content">
                    <div className="container">
                        <div id="search_param">
                            <Loading loadingShow={this.state.loadingShow} />
                            <form method="post" encType="multipart/form-data" action="">
                            <div className="select_param_1">
                                    <label>{this.state.pageData.length!==0 && this.state.pageData[0].F20301!== undefined?this.state.pageData[0].F20301:20301/*"نوع متن"*/}</label>
                                    <select className="form-control" id="search_book" name="search_book" onChange={this.onChangeBookGroupSelect}>
                                        {
                                        //<option value="-1" select="true">-</option>
                                        }
                                        {/* <option value={"All"}>همه</option> */}
                                        {   this.state.BookGroups != null 
                                            ?
                                            (   
                                                this.state.BookGroups.map((BookGroup) =>{
                                                    return  (
                                                        <option key={'BG'+BookGroup.Code} value={BookGroup.Code}>{BookGroup.Title}</option> 
                                                    )
                                                })
                                            )
                                            :
                                            <option key="-1">-</option>       
                                        }
                                    </select>
                                </div>
                                <div className="select_param_1">
                                    { 
                                        (this.state.SelectedBookGroup==="2")
                                        ?
                                        <label>{this.state.pageData.length!==0 && this.state.pageData[0].F20305!== undefined?this.state.pageData[0].F20305:20305/*نوع کتیبه*/}</label>
                                        :
                                        <label>{this.state.pageData.length!==0 && this.state.pageData[0].F20302!== undefined?this.state.pageData[0].F20302:20302/*نام متن*/}</label>
                                    }
                                    <select className="form-control" id="search_book" name="search_book" onChange={this.onChangeBookSelect}>
                                        {
                                        //<option value="-1" select="true">-</option>
                                        <option key='BAll' value={"All"}>
                                            {this.state.pageData.length!==0 && this.state.pageData[0].F29902!== undefined?this.state.pageData[0].F29902:29902/*"همه"*/}</option>
                                        }
                                        {   this.state.books != null 
                                            ?
                                            (   
                                                this.state.books.map((book) =>{
                                                    return  (
                                                        <option key={'B'+book.Code} value={book.Code}>{book.Title}</option> 
                                                    )
                                                })
                                            )
                                            :
                                            <option key="-1">-</option>       
                                        }
                                    </select>
                                </div>
                                <div className="select_param_1">
                                    { 
                                        (this.state.SelectedBookGroup==="2")
                                        ?
                                        <label>{this.state.pageData.length!==0 && this.state.pageData[0].F20306!== undefined?this.state.pageData[0].F20306:20306/*نام کتیبه*/}</label>
                                        :
                                        <label>{this.state.pageData.length!==0 && this.state.pageData[0].F20303!== undefined?this.state.pageData[0].F20303:20303/*شماره فصل*/}</label>
                                    }
                                    <select className="form-control" id="search_chapter" name="search_chapter" onChange={this.onChangeChapterSelect}>
                                        
                                        {
                                            //<option value="-1" select="true">-</option>
                                        }
                                            
                                        {   this.state.chapters != null 
                                            ?
                                            (   
                                                this.state.chapters.map((chapter,i) =>{
                                                    return  (
                                                        (this.state.chapters.length>1 && i===0)
                                                        ?
                                                        (
                                                            <>
                                                                <option key="All" value="All" select="true">
                                                                    {this.state.pageData.length!==0 && this.state.pageData[0].F29902!== undefined?this.state.pageData[0].F29902:29902/*"همه"*/}
                                                                </option>
                                                                <option key={chapter.Code} value={chapter.Code}>{chapter.Title}</option>
                                                            </>
                                                        )
                                                        :
                                                        (
                                                            (this.state.chapters.length===0 && i===0)
                                                            ?
                                                            (
                                                                <option key={-1} value={-1}>-1</option>
                                                            )
                                                            :
                                                            (
                                                                <option key={chapter.Code} value={chapter.Code}>{chapter.Title}</option>
                                                            )
                                                        )
                                                    )
                                                })
                                            )
                                            :
                                            <option key="-1">-</option>       
                                        }
                                    </select>
                                </div>
                                
                                <div className="select_param_1">
                                    <label>{this.state.pageData.length!==0 && this.state.pageData[0].F20304!== undefined?this.state.pageData[0].F20304:20304/*مقوله دستوری*/}</label>
                                    <select className="form-control" id="search_paragraph" name="search_paragraph" onChange={this.onChangeWordCategorySelect}>
                                    {/* <option value="-1" select="true">-</option> */}
                                        <option value={"None"}>-</option>
                                        {   this.state.wordcategory != null 
                                            ?
                                            (   this.state.wordcategory.map((wordcategory) =>{
                                                    return  (
                                                                <option key={wordcategory.Code} value={wordcategory.Code}>{wordcategory.Title}</option> 
                                                            )
                                                })
                                            )
                                            :
                                            <option key="-1">-</option>       
                                        }
                                    </select>
                                </div>
                                <button type="button" className="collapsible" onClick={this.onCollapsibleButtonClick}>{this.state.filterTitle}</button>
                                <div className="content search_params_2">
                                    {   
                                        ((this.state.wordpropertytype)&&(this.state.wordpropertytype != null)&&(this.state.wordpropertytype.length>0))
                                        ?
                                        (
                                            this.state.wordpropertytype.map((wordpropertytype) =>{
                                                return  (
                                                            <div className="outer100">
                                                                <div className="inner-title25">
                                                                    {wordpropertytype.Title}
                                                                </div>
                                                                <div className="inner-content75">                                        
                                                                    <select onChange={this.onChangeWordPropertySelect} id={wordpropertytype.Code} className="SelectItems">
                                                                        <option value={"All"}>
                                                                            {this.state.pageData.length!==0 && this.state.pageData[0].F29902!== undefined?this.state.pageData[0].F29902:29902/*"همه"*/}
                                                                        </option>
                                                                        {   wordpropertytype.WordPropertys != null 
                                                                            ?
                                                                            (   wordpropertytype.WordPropertys.map((WordProperty) =>{
                                                                                    return  (
                                                                                                <option value={WordProperty.Code}>{WordProperty.Title}</option> 
                                                                                            )
                                                                                })
                                                                            )
                                                                            :
                                                                            <option key="-1">-</option>       
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )
                                            })
                                        )
                                        :
                                        null
                                    }
                                    
                                </div>
                                <div className="fullwidth_div">
                                    <input type="submit" className="submit_button" value={this.state.pageData.length!==0 && this.state.pageData[0].F29901!== undefined?this.state.pageData[0].F29901:29901/*"جستجو"*/} onClick={this.onSearchButtonClick} />
                                    </div>
                            </form>
                        </div>
                    </div>
                </div>
                ,
                <br />
                ,
                (this.state.results && this.state.results.length>0)
                ?
                <div style={{ width:'80%',margin:'auto',paddingBottom:'10%'}}>
                    <TagResultList  results={this.state.results}
                                    pageData={this.state.pageData}
                    />
                </div>
                :
                <EmptyDiv />
                ,
                <Loading loadingShow={this.state.loadingShow} />
            ]
        )
    }
}

export default TagsBody;